import { useNavigate } from "react-router-dom";
import styles from "./ProductsHub.module.css";
import { Inventory, Category } from "@mui/icons-material";

const ProductsHub = () => {
  const navigate = useNavigate();

  const menuOptions = [
    {
      title: "Cadastro de produtos",
      onClick: () => {
        navigate("products");
      },
      icon: <Inventory sx={{ fontSize: 50 }} />,
    },
    {
      title: "Categoria de produtos",
      onClick: () => {
        navigate("category");
      },
      icon: <Category sx={{ fontSize: 50 }} />,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          <h1>Administração de Produtos</h1>
        </div>
        <div className={styles.cardGrid}>
          {menuOptions.map((option, index) => (
            <div
              key={index}
              className={`${styles.navCard} `}
              onClick={option.onClick}>
              <div className={styles.iconContainer}>{option.icon}</div>
              <span className={styles.cardTitle}>{option.title}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsHub;
